import { Inject, Injectable } from '@angular/core'
import { STANDALONE_APP_CONFIGURATION, StandaloneAppConfiguration } from '@ftr/api-shared'
import { WindowRefService } from '@ftr/ui-core'

@Injectable()
export class DeepLinkService {
  constructor(
    private readonly windowRefService: WindowRefService,
    @Inject(STANDALONE_APP_CONFIGURATION) private readonly configurationService: StandaloneAppConfiguration,
  ) {}

  openDeepLink(url?: string | undefined): void {
    const targetUrl = url ?? this.windowRefService.location().href

    this.windowRefService.open(targetUrl.replace('https', this.configurationService.desktopUriScheme), '_self')
  }
}
